import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage } from "@/comn/hooks";
import { BASE, URLS, APIS, SG_USR_DTL_LIST } from "@/tra/tancis/ptli/prcsmntr/xtrnusr/service/PtliXtrnUsrPrcsService";

/*
 * Detailed inquiry of external user account processing status
 * !== 외부 사용자 계정처리현황 상세 조회 ==!
 */
export const PTLI0602002Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const { xtrnUsrIdntfNo } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        usrSrchDtlList: useGrid({
            defaultSchema: SG_USR_DTL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get the list of external user account processing status. !== 외부 사용자 계정처리현황 상세 목록을 조회한다. ==!
        getUsrDtlList: useFetch({
            api: (page = grid.usrSrchDtlList.page) =>
                APIS.getXtrnUsrPrcsHistList(xtrnUsrIdntfNo, page, grid.usrSrchDtlList.size),
            enabled: comnUtils.isEmpty(xtrnUsrIdntfNo),
            key: [grid.usrSrchDtlList.page, grid.usrSrchDtlList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    page: grid.usrSrchDtlList.page,
                    size: grid.usrSrchDtlList.size,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {
                            navigate(URLS.ptli0602001q);
                        },
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00025" }); // Failed to select. !== 조회가 실패하였습니다. ==!
            },
        }),
    };

    /*
     * Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getUsrDtlList.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.usrSrchDtlList.grid} data={fetch.getUsrDtlList.data?.xtrnUsrHistList} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            navigate(`${URLS.ptli0602001q}`);
                        }}
                    >
                        {t("B_PRE")}
                    </Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
